export default{
    loadImages(images){
        for (let index = 0; index < images.length; index++) {
            images[index]=this.loadImage(images[index]);        
          }
        return images;
    },
    loadImage(image){
        return require("@/assets/"+image);
    }
}